module.exports = __webpack_public_path__ + "img/dec14_03.839de527.jpeg";